import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=c79f0b40&"
import script from "./DocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=c79f0b40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports